const ua = window.navigator.userAgent;

/**
 * @reference 部分判断参考 https://github.com/hgoebl/mobile-detect.js
 */
export const detectEnv = {
  /**
   * webview
   */
  webview: /orale/i.test(ua),
  /**
   * iOS
   */
  ios: /\biPhone|\biPod|\biPad|AppleCoreMedia/i.test(ua),
  /**
   * Android
   */
  android: /Android/i.test(ua),
  /**
   * HarmonyOS Next
   */
  harmony: /ArkWeb/i.test(ua),
};
